export default __webpack_public_path__ + "static/bg-abandoned-robot-b9a70cc09793c6e0b6ce8318994600ef.jpg";